const Wrapper = require("./src/components/Wrapper").default
const React = require("react")

exports.wrapPageElement = ({element, props}) => {

    return (
            <Wrapper props={props} element={element}>
            </Wrapper>
    );
}
